import { t as loggerUtils } from "./Logging-BxRsYlKX.js";
import { useCallback, useState } from "react";
import { partial } from "lodash-es";
//#region src/BrowserStorage/utils.ts
var nullableLocalStorage = null;
var nullableSessionStorage = null;
try {
	nullableLocalStorage = window.localStorage;
} catch {}
try {
	nullableSessionStorage = window.sessionStorage;
} catch {}
var BrowserStorageType = /* @__PURE__ */ function(BrowserStorageType) {
	BrowserStorageType[BrowserStorageType["LOCAL_STORAGE"] = 0] = "LOCAL_STORAGE";
	BrowserStorageType[BrowserStorageType["SESSION_STORAGE"] = 1] = "SESSION_STORAGE";
	return BrowserStorageType;
}({});
function getBrowserStorage(browserStorageType) {
	switch (browserStorageType) {
		case 0: return nullableLocalStorage;
		case 1: return nullableSessionStorage;
		default: throw new Error(`Unknown Browser storage type: ${browserStorageType}`);
	}
}
function isPayloadValid(payloadWrapper, options) {
	const { validTimeInMilliseconds = Number.MAX_VALUE } = options;
	const { updatedAt } = payloadWrapper;
	return !!(updatedAt && Date.now() - updatedAt <= validTimeInMilliseconds);
}
function getValidBrowserStoragePayload(browserStorageType, key, initialValue, options) {
	try {
		const item = getBrowserStorage(browserStorageType)?.getItem(key);
		const payloadWrapper = item && JSON.parse(item);
		if (payloadWrapper && isPayloadValid(payloadWrapper, options)) return payloadWrapper.payload;
		return initialValue;
	} catch {
		return initialValue;
	}
}
function setBrowserStoragePayload(browserStorageType, key, payload) {
	try {
		const payloadWrapper = {
			updatedAt: Date.now(),
			payload
		};
		getBrowserStorage(browserStorageType)?.setItem(key, JSON.stringify(payloadWrapper));
	} catch (error) {
		loggerUtils.logException(error);
	}
}
function clearBrowserStoragePayload(browserStorageType, key) {
	try {
		getBrowserStorage(browserStorageType)?.removeItem(key);
	} catch (error) {
		loggerUtils.logException(error);
	}
}
function clearBrowserStorage(browserStorageType) {
	try {
		getBrowserStorage(browserStorageType)?.clear();
	} catch (error) {
		loggerUtils.logException(error);
	}
}
//#endregion
//#region src/BrowserStorage/useBrowserStorageState.tsx
function useBrowserStorageState(browserStorageType, key, initialValue, options = {}) {
	const [storedValue, setStoredValue] = useState(() => {
		return getValidBrowserStoragePayload(browserStorageType, key, initialValue, options);
	});
	return [
		storedValue,
		useCallback((param) => {
			if (typeof param === "function") setStoredValue((currentValue) => {
				const newValue = param(currentValue);
				setBrowserStoragePayload(browserStorageType, key, newValue);
				return newValue;
			});
			else {
				setStoredValue(param);
				setBrowserStoragePayload(browserStorageType, key, param);
			}
		}, [key, browserStorageType]),
		useCallback(() => {
			clearBrowserStoragePayload(browserStorageType, key);
		}, [key, browserStorageType])
	];
}
var useLocalStorageState = partial(useBrowserStorageState, BrowserStorageType.LOCAL_STORAGE);
var useSessionStorageState = partial(useBrowserStorageState, BrowserStorageType.SESSION_STORAGE);
//#endregion
export { clearBrowserStorage as i, useSessionStorageState as n, BrowserStorageType as r, useLocalStorageState as t };

//# sourceMappingURL=BrowserStorage-XBdkz9k6.js.map